module.exports = __webpack_public_path__ + "bin/02ee2eff58629340c1d2ed3a0c59401b.jpg";